import { motion } from "framer-motion";
import BottomNavbar from "../components/BottomNavbar";
import Navbar from "../components/Navbar";
import { useGoogleLogin } from "@react-oauth/google";
import axios from "axios";
import { FcGoogle } from "react-icons/fc";
// import { account, ID } from "../appWrite";
import { useAppDispatch } from "../redux/hooks";
import { addProfile } from "../redux/slices/ProfileSlice";
import { useNavigate } from "react-router-dom";
import { FaMailBulk } from "react-icons/fa";

const AuthPage: React.FC = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const handleGoogleLogin = useGoogleLogin({
    onSuccess: async (response: any) => {
      // Save modal state in session storage
      sessionStorage.setItem("modal_shown", "true");
      console.log("Google Login Success:", response);

      // Fetch user details from Google
      const res = await axios.get(
        `https://www.googleapis.com/oauth2/v1/userinfo?alt=json&access_token=${response.access_token}`
      );

      const user = res.data;
      console.log("User Info:", user);
      dispatch(
        addProfile({
          id: user.id,
          name: user.name,
          token: "token", // This is just an example, adjust based on your needs
          role: "user", // Include the role
          email: user.email,
        })
      );

      // try {
      //   // Check if user exists
      //   const appwriteUser = await account.get();
      //   console.log("Appwrite User Exists:", appwriteUser);
      //   dispatch(
      //     addProfile({
      //       id: appwriteUser.$id,
      //       name: appwriteUser.name,
      //       token: "token", // This is just an example, adjust based on your needs
      //       role: "user", // Include the role
      //       email: appwriteUser.email,
      //     })
      //   );
      //   navigate("/products");
      // } catch (error) {
      //   console.log("User does not exist, creating...");

      //   // Create user in Appwrite
      //   await account.create(ID.custom(user.id), user.email, user.name);
      // }

      // Generate JWT for authentication
      // const jwt = await account.createJWT();
      // console.log("User JWT:", jwt.jwt);

      // // Store token in local storage
      // localStorage.setItem("auth_token", jwt.jwt);

      // Save modal state in session storage
      sessionStorage.setItem("modal_shown", "true");
      navigate("/products");
    },
    onError: (error: any) => console.error("Google Login Failed:", error),
  });

  return (
    <>
      <Navbar current="profile" />
      <div className="flex items-center justify-center min-h-screen bg-gray-100 px-4">
        <motion.div
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          className="bg-white p-6 md:p-8 rounded-lg shadow-lg w-full max-w-sm sm:max-w-md text-center"
        >
          <h2 className="text-lg sm:text-xl font-semibold">
            Login to Continue
          </h2>
          <p className="text-gray-500 text-sm my-2">
            Sign in with your Google account to access exclusive features.
          </p>

          <button
            onClick={() => handleGoogleLogin()}
            className="flex items-center justify-center w-full bg-white border border-gray-300 text-black font-medium py-2 rounded-lg hover:bg-gray-100 transition-all duration-300"
          >
            <FcGoogle className="text-2xl mr-2" />
            Sign in with Google
          </button>

          <button
            onClick={() => navigate("/login")}
            className="flex items-center justify-center w-full bg-white border border-gray-300 text-black font-medium py-2 rounded-lg hover:bg-gray-100 transition-all duration-300 mt-2"
          >
            <FaMailBulk className="text-2xl mr-2" />
            Sign in with Email
          </button>
        </motion.div>
      </div>

      <BottomNavbar current="profile" />
    </>
  );
};

export default AuthPage;
